// extracted by mini-css-extract-plugin
export default {"control":"control_control__Y1o3M","button":"control_button__slGpd"};